import React from "react";
import MapSearch from "../components/mapView/MapSearch";
const LayoutDefault = ({ children }) => (
  <>
    <MapSearch className="center-content mt-24 pt-8 container-sm"></MapSearch>
  </>
);

export default LayoutDefault;
